export default __webpack_public_path__ + "static/media/HipExtensionAtTerminalSwing.da3f66f5.png";